import styled, { css } from "styled-components";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { PopoverButton } from "../../../../../common-deprecated/styles/v2/toyota/components/Tooltip";

export const Wrapper = styled.div`
    height: auto;
    padding: 0 0 ${theme.space[2]}px;
    text-align: start;
`;

export const Title = styled.span.attrs(() => ({
    className: "t-milli-text",
}))`
    color: ${theme.colors.grey4};

    ${PopoverButton} {
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        ${PopoverButton} {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;

export const Value = styled.span.attrs<{ heading?: boolean }>((props) => ({
    className: `t-base-${props.heading ? "headline mb-0" : "text"}`,
}))<{ isLoading?: boolean; discountedPrice?: boolean; heading?: boolean }>`
    display: inline-block;
    position: relative;
    padding-right: ${theme.space[1]}px;
    text-decoration: ${({ discountedPrice }) => (discountedPrice ? "line-through" : "none")};
    color: ${({ discountedPrice }) => (discountedPrice ? theme.colors.grey3 : theme.colors.primaryBlack)};

    ${({ isLoading }) =>
        isLoading &&
        css`
            &::after {
                position: absolute;
                left: -5px;
                right: 0;
                width: 100%;
                width: 200px;
                color: ${theme.colors.grey1};
                content: "0";
                background: ${theme.colors.grey1};
                transition: width 0.3s ease;
                filter: blur(2px);
            }
        `};

    html[dir="rtl"] & {
        padding-left: ${theme.space[1]}px;
        padding-right: 0;
        ${({ isLoading }) =>
            isLoading &&
            css`
                &::after {
                    left: 0;
                    right: -5px;
                }
            `};
    }
`;

export const ValueWrapper = styled.div`
    display: flex;
`;

export const KeyValue = styled.div<{ hasSmallFontSize?: boolean }>`
    text-align: start;
    ${Value} {
        font-size: ${({ hasSmallFontSize }) => (hasSmallFontSize ? "1.3rem" : "1.6rem")};
        line-height: ${({ hasSmallFontSize }) => (hasSmallFontSize ? "2rem" : "2.4rem")};
    }
`;

export const Suffix = styled.span`
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.primaryBlack};
`;

export const Disclaimer = styled.button`
    padding: 0;
    background: transparent;
    border: none;

    svg,
    .icon {
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        svg,
        .icon {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;

export const DisclaimerIconWrapper = styled.span`
    display: flex;
    align-items: center;
    margin-left: ${theme.space[1]}px;

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export const LegalText = styled.div`
    margin: ${theme.space[1]}px 0 0;
    font-size: 1.3rem;
    line-height: 1.5;
    text-align: start;
    text-indent: 0;
    color: ${theme.colors.grey4};
`;
